<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1z4Y6K/images/MyCoverImage.jpg?1692269879808" alt="This image is the cover for the book Heiress"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heiress
      </h1>
      <p class="bookDescription body article font2">
        <p>Charles Macdonald and his parents, exiled Scots, take refuge at the splendid and decadent eighteenth-century Versailles court of Louis XV. Charles, a ruthless and degenerate young man, is soon forced by his gambling debts into an arranged marriage with his cousin, Anne. Anne is beautiful and wealthy—and in love with Charles. But none of this prevents him from carrying on with his mistress, the Baroness de Vitale, who in turn inflicts cruelties and humiliations upon Anne.<br/>  <br/> When Anne finds that her life is in danger, Charles must decide what sort of man he wants to be, and which woman he truly cares for.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Evelyn Anthony
      </h2>
      
      <p class="authorDescription body article">Evelyn Anthony is the pen name of Evelyn Ward-Thomas (1926&ndash;2108), a female British author who began writing in 1949. She gained considerable success with her historical novels&mdash;two of which were selected for the American Literary Guild&mdash;before winning huge acclaim for her espionage thrillers. Her book, <I>The Occupying Power</I>, won the Yorkshire Post Fiction Prize, and her 1971 novel, <I>The Tamarind Seed</I>, was made into a film starring Julie Andrews and Omar Sharif. Anthony&rsquo;s books have been translated into nineteen languages.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a26e726